import { createContext, useEffect, useState } from "react";
import { loadCoins } from "../utils/loadCoins";

export const CoinContext = createContext();

export const CoinProvider = ({ children }) => {
  const [coins, setCoins] = useState([]);
  const [categories, setCategories] = useState(["all"]);
  const [selectedCategory, setSelectedCategory] = useState("all");

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const allCoins = () =>
    loadCoins({
      setCoins,
      setCategories,
      setError,
      // setLoading,
    });

    useEffect(() => {
      const init = async () => {
        setLoading(true);
        await allCoins();
        setLoading(false);
      };
      init();
      
      const interval = setInterval(() => {
        allCoins();
      }, 15000);
      return () => clearInterval(interval);
    }, []);

  return (
    <CoinContext.Provider
      value={{
        coins,
        categories,
        selectedCategory,
        setSelectedCategory,
        loading,
        error,
        refresh: allCoins,
      }}
    >
      {children}
    </CoinContext.Provider>
  );
};